import {FC} from "react";

const NotFound: FC = () => {
    return (
        <div>
            Upss..
        </div>
    );
};

export default NotFound;